module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAYAAAD7PHgWAAAABGdBTUEAALGPC/xhBQAAARFJREFUWAntlrEKwjAQQC9VB3ESh+Kqq4LfIfoTuvk5im6CP9H+RgVx8QdKJ8eC2MZELARLoNw1UuECpUeTu7y+yxAhpQwAYK6eJo5QKEDZRLKCySuCpr4ZkNoZNsgGqQao+XwG2SDVADW/njMoMyqHNZ8GqMDiaAvJ9WTdgDqBB9Rw5z14nR74kxWVw5qPAyzBCesG1AnUfTCOdpBnD0jvt8r7D8ZL6I8WldcXC1GA8DZ4AK/dBX+6VrXcGcS1WLRgONtA/kwhuRwVoLtLOQ5Q+y9B6o/1D1yLvzlUyzWwi1EPoAuyT018ix1CmaUZ0LSBidkgxpqZwwZNG5iYDWKsmTls0LSBif/CYIj5sx/lBC8mn0nqWUtX9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/button_l2.png
// module id = yJ0z
// module chunks = 1